Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "group-list2461029283",
  {"root":"group-list2461029283--root"},
  "",
  8,
  "group-list2461029283"
);

